import { jsx as _jsx } from "react/jsx-runtime";
import { Content as RadixPopoverContent, Portal, } from "@radix-ui/react-popover";
import clsx from "clsx";
import { forwardRef } from "react";
import styles from "./content.module.css";
const PopoverContent = forwardRef((props, ref) => {
    const { className, sideOffset = 8, ...otherProps } = props;
    return (_jsx(Portal, { children: _jsx(RadixPopoverContent, { ...otherProps, ref: ref, sideOffset: sideOffset, className: clsx(styles.popover_content, className) }) }));
});
PopoverContent.displayName = "Popover.Content";
export { PopoverContent };
